import cjsConfig from './jest.cjs.config';
import esmConfig from './jest.esm.config';

export { cjsConfig, esmConfig };
